import { MessageDescriptor } from 'react-intl';

import partnerMessages from '../configs/Partnerships/messages';

/**
 * Selects the standard partnership/campaign terms copy for a trial and/or discount offer.
 * Brand offers never auto-renew, so they get variants without the renewal sentence.
 */
export function selectStandardOfferTerms(
	hasTrial: boolean,
	hasDiscount: boolean,
	isBrand = false,
): MessageDescriptor {
	if (hasTrial) return isBrand ? partnerMessages.loginSignupTerms_brand : partnerMessages.loginSignupTerms;
	if (hasDiscount) {
		return isBrand
			? partnerMessages.loginSignupTerms_noTrial_brand
			: partnerMessages.loginSignupTerms_noTrial;
	}
	return isBrand
		? partnerMessages.loginSignupTerms_noTrial_noPromo_brand
		: partnerMessages.loginSignupTerms_noTrial_noPromo;
}
